import { useAuth } from "@/context/AuthContext";
import { Building2 } from "lucide-react";
import { CompanyPanel } from "@/components/company/CompanyPanel";
import { useSearchParams } from "react-router-dom";

export default function Company() {
  const [sp] = useSearchParams();
  const { user } = useAuth();
  return (
    <div className="p-4 sm:p-6 lg:p-8 max-w-[1200px]" data-testid="company-page">
      <div className="mb-6">
        <div className="tag-mono text-blue-700 mb-1 flex items-center gap-1"><Building2 className="h-3 w-3" />MY COMPANY</div>
        <h1 className="text-2xl sm:text-3xl font-extrabold font-heading text-slate-900">{user?.company || "Company"}</h1>
        <p className="text-slate-600 mt-1">Contact card, secure logins and hazmat readiness — everything Safer Highways needs to file for you.</p>
      </div>
      <CompanyPanel customerId={user.id} isAdmin={false} defaultTab={sp.get("tab") || "card"} />
    </div>
  );
}
